class Wishlist {
  constructor() {
    this.storageKey = 'shopify-wishlist';
    this.items = this.getItems();

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wishlist-button]');

      if (!button) return;

      event.preventDefault();

      const product = {
        id: String(button.dataset.productId || ''),
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || '',
        image: button.dataset.productImage || ''
      };

      if (!product.id) return;

      this.toggle(product);
    });

    // Keep wishlist data synchronized between browser tabs.
    window.addEventListener('storage', (event) => {
      if (event.key === this.storageKey) {
        this.items = this.getItems();
        this.refreshUI();
      }
    });

    this.refreshUI();
  }

  getItems() {
    try {
      const stored = JSON.parse(
        localStorage.getItem(this.storageKey) || '[]'
      );

      if (!Array.isArray(stored)) return [];

      return stored.filter(
        item => item &&
          typeof item === 'object' &&
          item.id != null
      );
    } catch (error) {
      console.warn('Unable to read wishlist:', error);
      return [];
    }
  }

  get() {
    return this.items;
  }

  saveItems() {
    try {
      localStorage.setItem(
        this.storageKey,
        JSON.stringify(this.items)
      );
    } catch (error) {
      console.warn('Unable to save wishlist:', error);
    }

    this.refreshUI();

    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          wishlist: this.get()
        }
      })
    );
  }

  toggle(product) {
    if (!product || product.id == null) return;

    const productId = String(product.id);

    if (this.isInWishlist(productId)) {
      this.remove(productId);
    } else {
      this.items.push({
        id: productId,
        title: product.title || '',
        url: product.url || '',
        image: product.image || ''
      });

      this.saveItems();
    }
  }

  add(product) {
    if (!product || product.id == null) return;

    if (this.isInWishlist(product.id)) return;

    this.items.push({
      id: String(product.id),
      title: product.title || '',
      url: product.url || '',
      image: product.image || ''
    });

    this.saveItems();
  }

  remove(productId) {
    this.items = this.items.filter(
      item => String(item.id) !== String(productId)
    );

    this.saveItems();
  }

  clear() {
    this.items = [];
    this.saveItems();
  }

  isInWishlist(productId) {
    return this.items.some(
      item => String(item.id) === String(productId)
    );
  }

  updateButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(button => {
      const productId = button.dataset.productId;
      const active = this.isInWishlist(productId);

      button.classList.toggle('is-active', active);
      button.classList.toggle('is-saved', active);
      button.classList.toggle('wishlist-active', active);

      button.setAttribute(
        'aria-pressed',
        active ? 'true' : 'false'
      );

      const label = button.querySelector('.p-wishlist-label');

      if (label) {
        label.textContent = active
          ? 'Saved in Wishlist'
          : 'Wishlist';
      }

      // Preserve SVG markup.
      const heart = button.querySelector('.wishlist-heart');

      if (heart) {
        if (heart.tagName.toLowerCase() === 'svg') {
          heart.classList.toggle('is-filled', active);
        } else {
          heart.textContent = active ? '♥' : '♡';
        }
      }
    });
  }

  updateCount() {
    document.querySelectorAll('[data-wishlist-count]').forEach(element => {
      element.textContent = this.items.length;
    });
  }

  refreshUI() {
    this.updateButtons();
    this.updateCount();
  }

  updateUI() {
    this.refreshUI();
  }
}

// Initialize only once.
function initializeWishlist() {
  if (!window.shopifyWishlist) {
    window.shopifyWishlist = new Wishlist();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeWishlist
  );
} else {
  initializeWishlist();
}